<script lang="ts">
  import { store } from '$lib/store.svelte';

  interface Props { onCaptured?: () => void; onError?: (m: string) => void }
  let { onCaptured, onError }: Props = $props();
  let text = $state('');

  async function doCapture() {
    if (!text.trim()) return;
    try {
      await store.capturarIdea(text);
      text = '';
      onCaptured?.();
    } catch (e) {
      onError?.(e instanceof Error ? e.message : String(e));
    }
  }
</script>

<div class="capture-bar">
  <input
    type="text"
    class="capture-input"
    placeholder="¿Qué idea tenés?"
    bind:value={text}
    onkeydown={(e) => { if (e.key === 'Enter') { e.preventDefault(); doCapture(); } }}
    autocomplete="off"
  />
  <button type="button" class="capture-btn" onclick={doCapture}>Capturar</button>
</div>
